// ── Enums ──────────────────────────────────────────────────────────────────
/** Type of academic session */
export var SessionType;
(function (SessionType) {
    SessionType["ClassMeeting"] = "class_meeting";
    SessionType["Lab"] = "lab";
    SessionType["Discussion"] = "discussion";
    SessionType["Clinical"] = "clinical";
    SessionType["Studio"] = "studio";
    SessionType["Workshop"] = "workshop";
})(SessionType || (SessionType = {}));
/** Classification of an attendance event */
export var AbsenceType;
(function (AbsenceType) {
    AbsenceType["Unexcused"] = "unexcused";
    AbsenceType["Excused"] = "excused";
    AbsenceType["Late"] = "late";
    AbsenceType["EarlyDeparture"] = "early_departure";
    AbsenceType["Present"] = "present";
    AbsenceType["Cancelled"] = "cancelled";
})(AbsenceType || (AbsenceType = {}));
/** Reason category for an absence */
export var AbsenceReason;
(function (AbsenceReason) {
    AbsenceReason["Illness"] = "illness";
    AbsenceReason["Travel"] = "travel";
    AbsenceReason["ExcusedEvent"] = "excused_event";
    AbsenceReason["Personal"] = "personal";
    AbsenceReason["Family"] = "family";
    AbsenceReason["Work"] = "work";
    AbsenceReason["Transportation"] = "transportation";
    AbsenceReason["Other"] = "other";
})(AbsenceReason || (AbsenceReason = {}));
/** Risk level classification based on absence budget consumption */
export var RiskLevel;
(function (RiskLevel) {
    RiskLevel["Satisfactory"] = "satisfactory";
    RiskLevel["Warning"] = "warning";
    RiskLevel["AtRisk"] = "at_risk";
    RiskLevel["Critical"] = "critical";
})(RiskLevel || (RiskLevel = {}));
/** How the attendance policy calculates penalties */
export var PolicyRuleType;
(function (PolicyRuleType) {
    PolicyRuleType["PercentageBased"] = "percentage";
    PolicyRuleType["FixedCount"] = "fixed_count";
    PolicyRuleType["PerAbsenceDeduction"] = "per_absence";
})(PolicyRuleType || (PolicyRuleType = {}));
/** Type of session override (holiday, exam, make-up, etc.) */
export var SessionOverrideType;
(function (SessionOverrideType) {
    SessionOverrideType["Exam"] = "exam";
    SessionOverrideType["Presentation"] = "presentation";
    SessionOverrideType["LabPractical"] = "lab_practical";
    SessionOverrideType["GuestSpeaker"] = "guest_speaker";
    SessionOverrideType["MakeUp"] = "make_up";
    SessionOverrideType["Holiday"] = "holiday";
    SessionOverrideType["Cancelled"] = "cancelled";
})(SessionOverrideType || (SessionOverrideType = {}));
//# sourceMappingURL=index.js.map